import { UserRoleEnum } from "src/app/shared/enum/user-role.enum";

export class VerifyPermissionRequest {
    login: string;
    password: string;
    permissionEnum: UserRoleEnum;
}